<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>限制登录规则列表</h4>
        </div>
        <div class="main-bd mg20">
            <div style="width: 100%">
                <el-alert style="float: left;width: 90%" title="温馨提示: 满足限制规则的时候才会被限制，设置了IP段限制就只允许 设置的IP段 登录" type="success" close-text="朕知道了"></el-alert>
                <el-row class="addBtn">
                    <el-button type="primary" size="small" @click="addUser()" style="float: right;width: 8%;height: 35px;">+ 新增</el-button>
                </el-row>
            </div>
            <el-table :data="loginRules" style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="type_memo" label="限制类型"></el-table-column>
                <el-table-column prop="allow_range_text" label="限制对象" width="600px"></el-table-column>
                <el-table-column prop="allow_ips" label="允许登录IP段">
                    <template slot-scope="scope">
                        <p v-for="(ip, key) in scope.row.allow_ips">
                            {{ip}}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column column label="可用时间段">
                    <template slot-scope="scope">
                        <p v-for="(time, key) in scope.row.allow_times_text">
                            {{time}}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="updated_at" label="最后更新时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import {LoginRuleService} from "~/services/LoginRule";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        name: "index",
        components: {
            Pagination
        },
        data() {
            return {
                loading: false,
                loginRules: [],
                linkPage: null
            }
        },

        created() {
            if (this.loginRules.length < 1) {
                this.initListData();
            }
        },

        beforeRouteUpdate: function (to, from, next) {
            let params = this.searchModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initListData(params);
        },

        methods: {
            initListData(params = {}) {
                this.loading = true;
                LoginRuleService.getList(params).then(res => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.loginRules = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        return true;
                    }
                }).catch(err => {
                    console.error(err);
                })
            },

            handleUpdate(loginRule) {
                this.$router.push({
                    path: "/login-rules/update",
                    query: {
                        id: loginRule.id
                    }
                });
            },

            handleDelete(loginRule) {
                this.$confirm("确认要解绑该规则？").then(_ => {
                    LoginRuleService.delete(loginRule.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message.success('删除成功!');
                            this.initListData();
                        }
                    })
                }).catch(err => {
                    console.error(err);
                    return;
                });
            },
            addUser() {
                this.$router.push({
                    //    path: "/users/create"
                    path: "/login-rules/create"
                })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/login-rules/index.vue